import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { changeModal } from 'services/actions'
import lang from 'lang'
import { replace } from 'common/utils'
import { SubjectUser } from 'common/components/dashboard/user-item'

interface OwnProps {
  user?: SubjectUser
  single: boolean
}

const connector = connect(null, (dispatch) => ({
  changeModal: (params: Parameters<typeof changeModal>[0]) => dispatch(changeModal(params)),
}))

type Props = ConnectedProps<typeof connector> & OwnProps

class UserActivation extends React.Component<Props> {
  closeModal = (): void => {
    this.props.changeModal({ isOpen: false })
  }

  render(): React.ReactNode {
    return (
      <div className="modal-wrapper">
        <div className="modal-header" id="user-activation-data-header">
          <h2>
            {this.props.single && this.props.user
              ? replace(lang.dashboard.userActivationData.title, [this.props.user.name])
              : lang.dashboard.userActivationData.multipleTitle}
          </h2>
        </div>
        <div className="modal-container">
          <p>
            {this.props.single
              ? lang.dashboard.userActivationData.text
              : lang.dashboard.userActivationData.multipleText}
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="button ok" onClick={() => this.closeModal()}>
            {lang.okButton}
          </button>
        </div>
      </div>
    )
  }
}

export default connector(UserActivation)
